export const groupTableAdditionalColumnsKeys = {
    childCount: 'childCount',
} as const;
